var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacMauvaiseReponse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sac",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.77 434.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-2{stroke:#fff;}.cls-1,.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-9{stroke-miterlimit:10;}.cls-1{stroke-width:5px;}.cls-2{stroke-width:6px;}.cls-3{fill:#2a2a28;}.cls-4{fill:#f8b71f;}.cls-5{fill:#4c4e4d;}.cls-6{fill:#202120;}.cls-7{fill:#ffd02e;}.cls-8{fill:#1c1c1c;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-9{fill:none;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-9{stroke:#b3b3ba;stroke-width:2px;}.cls-10{stroke-dasharray:6.24 2.08;}.cls-11{opacity:0.67;}.cls-12{stroke-dasharray:6.17 2.06;}.cls-13{stroke-dasharray:3.69 1.23;}.cls-14{stroke-dasharray:4.77 1.59;}.cls-15{stroke-dasharray:5.92 1.97;}.cls-16{stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sac mauvaise r\xE9ponse 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2_mauvaise",
    "data-name": "2 mauvaise"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.07,834l-37.16,47",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1052.77,955.26c7.21-61.86,36-125.62,25.1-135.26C1054.22,799,974,792,974,792s-80.22,7-103.87,28c-10.85,9.64,14.15,67.65,21.37,129.5l-1,134h164Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.93,834l37.16,47",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M892.5,888.5l-27,58,74,34c17,5,22,28-7,28,0,0-103-21-113-55,1-46,37.24-121.6,50.63-133.5",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1052.26,885.5l27,58-74,34c-17,5-22,28,7,28,0,0,103-21,113-55-1-46-37.24-121.6-50.64-133.5",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 157.01,
    cy: 74,
    r: 71
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sac-2",
    "data-name": "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M973.73,1088.13s-63.92.73-66.35,0-2.43-1.21-2.43-1.21-7.53-.73-8.75-1.22-5.1-1.7-6.56-5.1-3.16-10.21-3.89-20.42c-4.86-7-8.74-26.73-9.23-30.86s-1-16.52.24-21.14a67.68,67.68,0,0,1,2.19-7s-.73-3.4-.24-4.37,4.37-1.7,4.61-1.7,3.65-1.22,3.65-2.19,6.07-48.36,8.75-56.38,12.76-33.29,21.38-37.43c-1.94-6.56-5.59-24-3.64-29.89.24-1,1.46-1,3.4-1S937,864.56,937,864.56a17.7,17.7,0,0,0,3.89-1,3.9,3.9,0,0,1,5.34,1L956.47,885l17.26-.24Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.73,975.69l-57.36-.08s-.79-12,4.86-16.28c2.92-2.18,7.29-2.67,12.16-2.67h40.34Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96.71 419.52 99.38 320.61 156.73 320.61 156.73 419.52 96.71 419.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M903.74,1074.52s6.07-102.55,7.77-108.38,7.78-11.91,11.18-12.4,23.57-2.91,31.59-3.4,19.5-1.39,19.5-1.39l-.09,3s-46.62,2.5-50.51,4.45-8,7.53-8.26,9.72-6.81,108.38-6.81,108.38Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M891.34,1080.84s3.65-24.54,4.86-40.58,7.78-85.79,6.57-95h-1.95s-12.64,103-12.64,114.7C888.18,1068,891.34,1080.84,891.34,1080.84Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M928.77,917.29H947s-1.7-27.22,0-33.78,4.14-21.87,3.89-24.06a4.55,4.55,0,0,1-1-.73s6.08-5.83,23.82-5.1v-6.56s-11.91-.73-22.36,2.92c-1.7.72-4.38.48-5.35,1.45s-1.7,3.41-4.62,7.54c-3.64,6.07-7.77,8.75-10,13.85S928.52,907.33,928.77,917.29Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 138.51,
    y: 326.45,
    width: 18.23,
    height: 12.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 98.9,
    y: 345.64,
    width: 57.84,
    height: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.42,1000.89s-.24-.73-1.46-.73-1.94,1.7-1.94,1.7h-1.7a2.26,2.26,0,0,1-.73,1.46c-.73.73,0,12.15,0,12.15s-.24,3.4,2.67,3.4a3.15,3.15,0,0,0,3.16-2.92s-1-7.53-1-9.23c.49-.24,1-1.46,1-1.46h3.16v-4.37Zm-3.16,17a1.95,1.95,0,1,1,2-1.95A1.94,1.94,0,0,1,920.26,1017.9Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M972.27,947.67l-1.95-.73s-4.37.24-4.61.73-1.71,1.46-1.22,2.18l.49.49s-1,4.38-.73,5.35a2.4,2.4,0,0,0,2.43,2.18c1.7,0,3.16-.72,3.4-1.7s-.49-4.86-.49-4.86h2.19a1.86,1.86,0,0,0,1-.73C973,950.1,972.27,947.67,972.27,947.67ZM967,956.9c-1.14,0-2.06-.54-2.06-1.21s.92-1.22,2.06-1.22,2.07.55,2.07,1.22S968.18,956.9,967,956.9Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M969.11,882.54l-3.65-.49-2.91,3.41h.72s-2.67,3.88-2.91,4.37a2.07,2.07,0,0,0,0,1.7c.24.24,5.35-1,5.83-1.21s.69-4.86.69-4.86h5.39v-1Zm-2.92,1.94,1.7-1,2.68.73.48.24Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 90.39,
    y1: 263.02,
    x2: 93.39,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 95.47,
    y1: 263.02,
    x2: 152.69,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 153.73,
    y1: 263.02,
    x2: 156.73,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 112.5,
    y1: 261.08,
    x2: 115.5,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 117.56,
    y1: 261.08,
    x2: 124.76,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 125.79,
    y1: 261.08,
    x2: 128.79,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 112.5,
    y1: 248.92,
    x2: 115.5,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 117.56,
    y1: 248.92,
    x2: 124.76,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 125.79,
    y1: 248.92,
    x2: 128.79,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 112.5,
    y1: 248.92,
    x2: 112.5,
    y2: 251.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 112.5,
    y1: 253.16,
    x2: 112.5,
    y2: 257.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 112.5,
    y1: 258.08,
    x2: 112.5,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 128.79,
    y1: 248.92,
    x2: 128.79,
    y2: 251.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 128.79,
    y1: 253.16,
    x2: 128.79,
    y2: 257.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 128.79,
    y1: 258.08,
    x2: 128.79,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 112.5,
    y1: 248.92,
    x2: 114.91,
    y2: 250.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 116.18,
    y1: 251.67,
    x2: 125.74,
    y2: 258.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 126.38,
    y1: 259.28,
    x2: 128.79,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 128.79,
    y1: 248.92,
    x2: 126.38,
    y2: 250.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 125.11,
    y1: 251.67,
    x2: 115.55,
    y2: 258.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 114.91,
    y1: 259.28,
    x2: 112.5,
    y2: 261.08
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 90.39,
    y1: 265.94,
    x2: 93.39,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 95.47,
    y1: 265.94,
    x2: 152.69,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 153.73,
    y1: 265.94,
    x2: 156.73,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M895,1074.28c.22.38,1.19.72,2.77,1",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M899.7,1075.6c12.07,1.64,44.68,1.91,70,1.43",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M970.72,1077l3-.06",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M973.73,1088.13s63.91.73,66.34,0,2.43-1.21,2.43-1.21,7.53-.73,8.75-1.22,5.1-1.7,6.56-5.1,3.16-10.21,3.89-20.42c4.86-7,8.75-26.73,9.23-30.86s1-16.52-.24-21.14a67.68,67.68,0,0,0-2.19-7s.73-3.4.24-4.37-4.37-1.7-4.61-1.7-3.65-1.22-3.65-2.19-6.07-48.36-8.75-56.38-12.76-33.29-21.38-37.43c1.94-6.56,5.59-24,3.64-29.89-.24-1-1.45-1-3.4-1s-20.17-3.64-20.17-3.64a17.7,17.7,0,0,1-3.89-1,3.9,3.9,0,0,0-5.34,1L991,885l-17.25-.24Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.73,975.69l57.35-.08s.79-12-4.86-16.28c-2.92-2.18-7.29-2.67-12.15-2.67H973.73Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.76 419.52 214.09 320.61 156.73 320.61 156.73 419.52 216.76 419.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1043.71,1074.52s-6.07-102.55-7.77-108.38-7.78-11.91-11.18-12.4-23.57-2.91-31.59-3.4-19.5-1.39-19.5-1.39l.09,3s46.62,2.5,50.51,4.45,8,7.53,8.27,9.72,6.8,108.38,6.8,108.38Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1056.11,1080.84s-3.65-24.54-4.86-40.58-7.78-85.79-6.56-95h1.94s12.64,103,12.64,114.7C1059.27,1068,1056.11,1080.84,1056.11,1080.84Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1018.68,917.29h-18.22s1.7-27.22,0-33.78-4.13-21.87-3.89-24.06a4.55,4.55,0,0,0,1-.73s-6.07-5.83-23.81-5.1v-6.56s11.9-.73,22.35,2.92c1.7.72,4.38.48,5.35,1.45s1.7,3.41,4.62,7.54c3.64,6.07,7.77,8.75,10,13.85S1018.93,907.33,1018.68,917.29Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 973.73,
    y: 981.45,
    width: 18.23,
    height: 12.15,
    transform: "translate(1148.68 1320.04) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 973.73,
    y: 1000.64,
    width: 57.84,
    height: 5.59,
    transform: "translate(1188.3 1351.88) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1020.87,1000.89v4.37H1024s.49,1.22,1,1.46c0,1.7-1,9.23-1,9.23a3.15,3.15,0,0,0,3.16,2.92c2.91,0,2.67-3.4,2.67-3.4s.73-11.42,0-12.15a2.26,2.26,0,0,1-.73-1.46h-1.7s-.73-1.7-1.94-1.7-1.46.73-1.46.73Zm4.37,15.06a1.95,1.95,0,1,1,2,1.95A2,2,0,0,1,1025.24,1016Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M974.7,950.58a1.86,1.86,0,0,0,1,.73h2.19s-.73,3.89-.49,4.86,1.7,1.7,3.4,1.7a2.4,2.4,0,0,0,2.43-2.18c.25-1-.73-5.35-.73-5.35l.49-.49c.49-.72-1-1.7-1.22-2.18s-4.61-.73-4.61-.73l-2,.73S974.45,950.1,974.7,950.58Zm3.64,5.11c0-.67.93-1.22,2.07-1.22s2.06.55,2.06,1.22-.92,1.21-2.06,1.21S978.34,956.36,978.34,955.69Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M975.18,884.48v1h5.39s.2,4.61.69,4.86,5.59,1.45,5.83,1.21a2.07,2.07,0,0,0,0-1.7c-.24-.49-2.91-4.37-2.91-4.37h.72L982,882.05l-3.65.49Zm1.22,0,.48-.24,2.68-.73,1.7,1Z",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 223.08,
    y1: 263.02,
    x2: 220.08,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 218,
    y1: 263.02,
    x2: 160.77,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 159.73,
    y1: 263.02,
    x2: 156.73,
    y2: 263.02
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.96,
    y1: 261.08,
    x2: 197.96,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 195.91,
    y1: 261.08,
    x2: 188.71,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 187.68,
    y1: 261.08,
    x2: 184.68,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.96,
    y1: 248.92,
    x2: 197.96,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 195.91,
    y1: 248.92,
    x2: 188.71,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 187.68,
    y1: 248.92,
    x2: 184.68,
    y2: 248.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.96,
    y1: 248.92,
    x2: 200.96,
    y2: 251.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 200.96,
    y1: 253.16,
    x2: 200.96,
    y2: 257.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.96,
    y1: 258.08,
    x2: 200.96,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 184.68,
    y1: 248.92,
    x2: 184.68,
    y2: 251.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 184.68,
    y1: 253.16,
    x2: 184.68,
    y2: 257.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 184.68,
    y1: 258.08,
    x2: 184.68,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.96,
    y1: 248.92,
    x2: 198.56,
    y2: 250.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 197.28,
    y1: 251.67,
    x2: 187.72,
    y2: 258.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 187.08,
    y1: 259.28,
    x2: 184.68,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 184.68,
    y1: 248.92,
    x2: 187.08,
    y2: 250.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 188.36,
    y1: 251.67,
    x2: 197.92,
    y2: 258.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 198.56,
    y1: 259.28,
    x2: 200.96,
    y2: 261.08
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 223.08,
    y1: 265.94,
    x2: 220.08,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 218,
    y1: 265.94,
    x2: 160.77,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 159.73,
    y1: 265.94,
    x2: 156.73,
    y2: 265.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1052.46,1074.28c-.22.38-1.18.72-2.77,1",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1047.75,1075.6c-12.07,1.64-44.68,1.91-70,1.43",
    transform: "translate(-816.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M976.73,1077l-3-.06",
    transform: "translate(-816.99 -655)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1070.69,1008.18a67.68,67.68,0,0,0-2.19-7s.73-3.4.24-4.37-4.37-1.7-4.61-1.7-3.65-1.22-3.65-2.19-6.07-48.36-8.75-56.38-12.76-33.29-21.38-37.43c1.94-6.56,5.59-24,3.64-29.89-.24-1-1.45-1-3.4-1s-20.17-3.64-20.17-3.64l-.34-.06a41.76,41.76,0,0,1-4-5.53c-2.92-4.13-3.65-6.56-4.62-7.54s-3.65-.73-5.35-1.45c-10.45-3.65-22.35-2.92-22.35-2.92s-11.91-.73-22.36,2.92c-1.7.72-4.38.48-5.35,1.45s-1.7,3.41-4.62,7.54a40.88,40.88,0,0,1-4,5.53l-.34.06s-18.23,3.64-20.17,3.64-3.16,0-3.4,1c-2,5.84,1.7,23.33,3.64,29.89-8.62,4.14-18.71,29.41-21.38,37.43S887,991.9,887,992.87s-3.4,2.19-3.65,2.19-4.13.72-4.61,1.7.24,4.37.24,4.37a67.68,67.68,0,0,0-2.19,7c-1.21,4.62-.73,17-.24,21.14s4.37,23.82,9.23,30.86c.73,10.21,2.43,17,3.89,20.42s5.35,4.61,6.56,5.1,8.75,1.22,8.75,1.22,0,.48,2.43,1.21,66.35,0,66.35,0,63.91.73,66.34,0,2.43-1.21,2.43-1.21,7.53-.73,8.75-1.22,5.1-1.7,6.56-5.1,3.16-10.21,3.89-20.42c4.86-7,8.75-26.73,9.23-30.86S1071.9,1012.8,1070.69,1008.18Zm-104.5-123.7,1.7-1,2.68.73.48.24Zm10.21,0,.48-.24,2.68-.73,1.7,1Zm-2.67-30.86c17.74-.73,23.81,5.1,23.81,5.1a4.55,4.55,0,0,1-1,.73c-.13,1.18.51,6.16,1.4,11.54l-7,14-6.57-.09L982,882.05l-3.65.49-3.16,1.94v.27l-1.45,0-1.46,0v-.27l-3.16-1.94-3.65-.49L963,884.88l-6.57.09-7-14c.89-5.38,1.53-10.36,1.4-11.54a4.55,4.55,0,0,1-1-.73S956,852.89,973.73,853.62Z",
    transform: "translate(-816.99 -655)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacMauvaiseReponse3);
export default __webpack_public_path__ + "static/media/sac_mauvaise_reponse_3.385c1008b1a4bd2f4aa1abd0f91ee67f.svg";
export { ForwardRef as ReactComponent };